<section class="talk-list-page">

    <div class="talk-list-header">
      <div>
        <h1>Pláticas ABAQ</h1>
        <p>Consulta las pláticas de bienestar animal registradas.</p>
      </div>
  
      <button
        type="button"
        class="copy-form-button"
        (click)="copyFormLink()"
        >
        🔗 Copiar enlace
        </button>
      @if (!showCreateForm) {
        <button
          type="button"
          class="create-talk-button"
          (click)="openCreateForm()"
        >
          + Nueva plática
        </button>
      }
    </div>
  
    @if (showCreateForm) {
      <div class="talk-form-card">
  
        <div class="talk-form-header">
          <div>
            <h2>Nueva plática</h2>
            <p>Registra una nueva plática de bienestar animal.</p>
          </div>
  
          <button
            type="button"
            class="close-form-button"
            (click)="closeCreateForm()"
          >
            ×
          </button>
        </div>
  
        <div class="talk-form-grid">
  
          <div class="talk-form-group">
            <label for="talkName">
              Nombre de la plática
            </label>
  
            <input
              id="talkName"
              type="text"
              placeholder="Ej. Bienestar Animal: Control poblacional"
              [(ngModel)]="newTalk.name"
            />
          </div>
  
          <div class="talk-form-group">
            <label for="talkDate">
              Fecha de la plática
            </label>
  
            <input
              id="talkDate"
              type="date"
              [(ngModel)]="newTalk.date"
            />
          </div>
  
          <div class="talk-form-group">
            <label for="talkLocation">
              Lugar
            </label>
  
            <input
              id="talkLocation"
              type="text"
              placeholder="Ej. Universidad Anáhuac Querétaro"
              [(ngModel)]="newTalk.location"
            />
          </div>
  
        </div>
  
        <div class="talk-survey-options">
  
          <label class="talk-checkbox">
            <input
              type="checkbox"
              [(ngModel)]="newTalk.entrySurvey"
            />
  
            <span>
              Encuesta de entrada
            </span>
          </label>
  
          <label class="talk-checkbox">
            <input
              type="checkbox"
              [(ngModel)]="newTalk.exitSurvey"
            />
  
            <span>
              Encuesta de salida
            </span>
          </label>
  
        </div>
  
        <div class="talk-form-actions">
  
          <button
            type="button"
            class="cancel-talk-button"
            (click)="closeCreateForm()"
          >
            Cancelar
          </button>
  
          <button
            type="button"
            class="save-talk-button"
            [disabled]="isCreatingTalk"
            (click)="createTalk()"
          >
            {{
              isCreatingTalk
                ? 'Guardando...'
                : 'Guardar plática'
            }}
          </button>
  
        </div>
  
      </div>
    }
  
    @if (isLoading) {
      <div class="loading-state">
        <p>Cargando pláticas...</p>
      </div>
    }
  
    @if (!isLoading && talks.length === 0) {
      <div class="empty-state">
        <p>No hay pláticas registradas.</p>
      </div>
    }
  
    @if (!isLoading && talks.length > 0) {
      <div class="talk-list">
  
        @for (talk of pagedTalks; track talk._id) {
          <article class="talk-card">
  
            <div class="talk-card-header">
              <div>
                <h2>{{ talk.name }}</h2>
  
                <p class="talk-location">
                  📍 {{ talk.location || 'Sin ubicación' }}
                </p>
              </div>
  
              <span class="talk-date">
                {{ talk.date | date:'mediumDate':'UTC' }}
              </span>
            </div>
  
            <div class="talk-card-body">
  
              <div class="talk-info">
                <span>Participantes</span>
                <strong>
                  {{ talk.participants?.length || 0 }}
                </strong>
              </div>
  
              <div class="talk-info">
                <span>Encuesta de entrada</span>
                <strong>
                  {{ talk.entrySurvey ? 'Sí' : 'No' }}
                </strong>
              </div>
  
              <div class="talk-info">
                <span>Encuesta de salida</span>
                <strong>
                  {{ talk.exitSurvey ? 'Sí' : 'No' }}
                </strong>
              </div>
  
            </div>
            <div class="talk-card-actions">
                <button
                  type="button"
                  class="view-talk-button"
                  (click)="viewTalk(talk._id)"
                >
                  Ver detalles
                </button>
              </div>
  
          </article>
        }
  
      </div>

      <app-pagination
        [(page)]="page"
        [totalItems]="talks.length"
        [pageSize]="pageSize"
      ></app-pagination>
    }
  
  </section>